import { styled } from "@mui/material/styles";
import { Backdrop, CircularProgress } from "@mui/material";

const CardBackdrop = styled((props) => (
    <Backdrop unmountOnExit {...props}>
        <CircularProgress color="secondary" />
    </Backdrop>
))(({ theme }) => ({
    position: "absolute",
    zIndex: 9999,
}));

export default CardBackdrop;